import {} from "../env/index.js";
import { formatValue } from "../value/index.js";
import {} from "./Parameter.js";
export function formatParameter(env, parameter) {
    const t = formatValue(env, parameter.t);
    if (parameter.isPrincipal) {
        return `${parameter.name}!: ${t}`;
    }
    else {
        return `${parameter.name}: ${t}`;
    }
}
//# sourceMappingURL=formatParameter.js.map